import axios from "axios";
import { Link } from "react-router-dom";
import { IoIosAdd } from "react-icons/io";
import React, { useState, useEffect } from "react";
import { Loader2 } from "./webWorkers/LoaderFile/Loader";
import { API_Link, validateHeader } from "../commons/Constants";

const AdminLevelListingComponent = () => {
  const MD5hash = validateHeader();
  const [levels, setLevels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const users = JSON.parse(localStorage.getItem("user"));
  const token = users.token;
  const getLevels = () => {
    setIsLoading(true);
    var config = {
      method: "get",
      url: `${API_Link}getLevels`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;
        setLevels(resData.data.levels);
        setIsLoading(false);

        //  console.log('Level APIs',resData.data.levels)
      })
      .catch(function (error) {
        setIsLoading(false);
        console.log(error);
      });
  };
  useEffect(() => {
    getLevels();
  }, []);
  return (
    <div className="page--content ">
      <div className="row sticky-title align-items-center">
        <div className="col-md-6 col-lg-6">
          <h1 className="page--heading ">Level Listing</h1>
        </div>
        <div className="col-sm-6 col-xs-12 text--align--right mt-1">
          <Link to="/admin/addLevel" className="tem--add--btn">
            <IoIosAdd /> Add New Level
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="padding-table">
          <div className="table--template ">
            <table className="table table-striped ">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Level</th>
                  <th>Description</th>
                  <th className="max-width-action">Action</th>
                </tr>
              </thead>
              <tbody>
                {!isLoading &&
                  levels &&
                  levels?.map((level, index) => (
                    <tr>
                      <td className="">{index + 1} </td>
                      <td>
                        {level.level.charAt(0).toUpperCase() +
                          level.level.slice(1)}
                      </td>
                      <td> {level.description}</td>
                      <td className="max-width-action">
                        <Link to="#" className="tem--add--btn">
                          Edit
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {isLoading && (
              <div className="role-listing-loader d-flex">
                <Loader2 />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLevelListingComponent;
